import React from 'react';
import Header from './header';
import PurchaseInvoiceCreateCore from '@/components/purchase-invoice/create';
import { Route } from '@/routes/(pharma)/_layout/inventory/purchase-invoice/create/index';

export default function Screen() {

  const data = Route.useLoaderData();
  const search = Route.useSearch();

  return (
    <div className="h-screen w-full max-w-screen flex flex-col overflow-hidden">
      <Header />
      <PurchaseInvoiceCreateCore suppliers={data.suppliers} purchaseOrders={data.purchaseOrders} instance_id={search.instance_id} stockPointId={data.stockPointId}/>
    </div>
  );
}
